export const consumerEn = {
  registrationType: {
    consumer: {
      introduction: {
        features: {
          feature1: 'Report content usage and compensate the publishers',
          // feature2: 'Access your transaction history',
          // feature3: 'Access your invoice history',
          feature4: 'Access to the consumer dashboard',
        },
      },
    },
  },   
  navbar_consumer: {
    aggregator: 'Aggregators',
    consumerInfo: 'Info',
    transactions: 'Transactions & Bank',
    reports: 'Reports',
    invoices: 'Invoices',
  },
  home_consumer: {
    title: 'My Page',
    description: 'This page displays information about the currently logged-in consumer.',
    myAccount: 'My Account',
    myAccountDescription: 'View your account information',
    invoices: 'My Invoices',
    invoicesDescription: 'View your invoices',
    reports: 'My Reports',
    reportsDescription: 'View your reports',
  },
  invoices: {
    title: 'Invoices',
    perPublisher: {
      title: 'Invoice details per Publisher',
      content: 'This page displays your invoice details for content consumption per publisher. View invoice details, date ranges. Click on an publisher link to see the invoice details.',
    },
    backToInvoices: 'Back to Invoices',
    loading: 'Loading invoices...',
    error: 'Error loading invoices: {error}',
    noInvoices: 'No invoices found.',
    dates: 'Dates',
    invoiceId: 'Invoice ID',
    tag: 'Tag',
    price: 'Price',   
    points: 'Points',
    status: 'Status',
    total: 'Total',
    paid: 'Paid',
    pending: 'Pending',
    overdue: 'Overdue',
    refused: 'Refused',
    inNegotiation: 'In negotiation',
    notified: 'Notified',
    pendingAmount: 'Pending amount',
    currency: 'Currency',
    dueDate: 'Due date',
    createdAt: 'Created at',
    failedFetch: 'Failed to fetch invoices',
    nA: 'N/A',
    description: {
      title: 'About this page',
      content: 'This page displays your invoices for content consumption. View invoice details, date ranges, and tags. Click on an invoice to see more information.',
    },
    summary: {
      totalInvoiced: 'Total invoiced',
      totalPaid: 'Total paid',
      totalPending: 'Total pending',
      totalOverdue: 'Total overdue',
      totalRefused: 'Total refused',
      totalInNegotiation: 'Total in negotiation',
      totalNotified: 'Total notified',
      pendingAmount: 'Pending amount',
      currency: 'Currency',
      dueDate: 'Due date',
      createdAt: 'Created at',
    }
  },
  consumerReportList: {
    title: 'Consumption Reports',
    description: {
      title: 'About this page',
      content: 'This page displays your consumption reports showing which content you have accessed and the points consumed. View detailed information about each report including content IDs, reporting dates, and consumption amounts.',
    },
  },
};